import { render, staticRenderFns } from "./OAuthCallbackView.vue?vue&type=template&id=39e5ebdf&scoped=true&"
import script from "./OAuthCallbackView.vue?vue&type=script&lang=js&"
export * from "./OAuthCallbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e5ebdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VFlex})
